<template>
  <div class="user-image">
    <div
      :class="{ img: true, 'is-banned': !user.status }"
      v-if="user.profileImageURL"
      :style="{ 'background-image': `url(${user.profileImageURL})` }"
      alt=""
    ></div>
    <img v-else :src="defaultImage" alt />
    <span v-if="!user.status" class="banned-icon">!</span>
  </div>
</template>

<script>
import userColorHelper from '@/components/shared/users/userColorHelper';

export default {
  name: 'UserImage',
  props: {
    user: {
      type: Object,
    },
  },
  computed: {
    placeholderImageURL() {
      const url = `https://via.placeholder.com/500x500/${userColorHelper.intToRGB(
        userColorHelper.hashCode(this.user._id.toString())
      )}/FFF/?&text=${this.nameInitial}a&`;
      return encodeURIComponent(url);
    },
    nameInitial() {
      if (!this.user || !this.user.firstName || !this.user.lastName) {
        return '';
      }
      return this.user.firstName.charAt(0) + this.user.lastName.charAt(0);
    },
    defaultImage() {
      const userHash = userColorHelper.hashCode(this.user._id.toString());
      const profileImageIndex = Math.abs(userHash) % 23;
      return `/static/images/icons/profile-images/default_${profileImageIndex}.svg`;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.user-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .is-banned {
    opacity: 0.9;
    -webkit-filter: grayscale(1);
    filter: grayscale(1);
  }
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 50%;
    background-color: rgba(233, 233, 248, 1);
  }
  .img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }
  .banned-icon {
    font-size: 12px;
    color: red;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #fff;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

